<template>
  <main class="become-model">
    <validation-observer slim ref="form">
      <form
        novalidate
        class="application-form"
        @submit.prevent="submitForm"
      >
        <div class="application-form__left">
          <p class="application-form__info application-form__info_desktop">
            Если Вы хотите стать моделью<br>
            Standard Model Management, Вам нужно<br>
            заполнить анкету и добавить фотографии<br>
            по которым хорошо видно, как Вы выглядите.<br>
            Фотографии не должны превышать 5 mb.
          </p>
          <p class="application-form__info application-form__info_mobile">
            Если Вы хотите стать моделью Standard Model Management, 
            Вам нужно заполнить анкету и добавить фотографии по 
            которым хорошо видно, как Вы выглядите. 
            Фотографии не должны превышать 5 mb.
          </p>
          <validation-provider slim vid="name" rules="required" v-slot="{ errors }">
            <base-input
              class="application-form__input"
              v-model="request.name"
              type="text"
              placeholder="Имя Фамилия"
              :error="errors.length > 0"
            ></base-input>
          </validation-provider>
          <validation-provider slim vid="location" rules="required" v-slot="{ errors }">
            <base-input
              class="application-form__input"
              v-model="request.location"
              type="text"
              placeholder="Страна, город"
              :error="errors.length > 0"
            ></base-input>
          </validation-provider>
          <validation-provider slim vid="phoneNumber" rules="required" v-slot="{ errors }">
            <base-input
              class="application-form__input"
              v-model="request.phone"
              type="tel"
              pattern="((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}"
              placeholder="Номер телефона"
              :error="errors.length > 0"
            ></base-input>
          </validation-provider>
          <validation-provider slim vid="email" rules="required|email" v-slot="{ errors }">
          <base-input
            class="application-form__input"
            v-model="request.email"
            type="email"
            placeholder="Email"
            :error="errors.length > 0"
          ></base-input>
          </validation-provider>
          <validation-provider slim vid="link" rules="required" v-slot="{ errors }">
            <base-input
              class="application-form__input"
              v-model="request.link"
              type="text"
              placeholder="Ссылка на вас"
              :error="errors.length > 0"
            ></base-input>
          </validation-provider>
          <validation-provider slim vid="age" rules="required|numeric" v-slot="{ errors }">
            <base-input
              class="application-form__input"
              v-model.number="request.age"
              type="number"
              placeholder="Возраст"
              :error="errors.length > 0"
            ></base-input>
          </validation-provider>
          <validation-provider slim vid="height" rules="required|numeric" v-slot="{ errors }">
          <base-input
            class="application-form__input"
            v-model.number="request.height"
            type="number"
            placeholder="Рост"
            :error="errors.length > 0"
          ></base-input>
          </validation-provider>
        </div>
        <div class="application-form__right">
          <div class="application-form__photos">
            <validation-provider
              slim
              vid="nomakeup1"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.nomakeup1"
                :error="errors.length > 0"
                deskr="портрет в профиль без макияжа"
              ></base-image-input>
            </validation-provider>
            <validation-provider
              slim
              vid="nomakeup2"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.nomakeup2"
                :error="errors.length > 0"
                deskr="портрет в профиль без макияжа"
              ></base-image-input>
            </validation-provider>
            <validation-provider
              slim
              vid="nomakeup3"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.nomakeup3"
                :error="errors.length > 0"
                deskr="портрет в анфас без макияжа"
              ></base-image-input>
            </validation-provider>
            <validation-provider
              slim
              vid="portrait"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.portrait"
                :error="errors.length > 0"
                deskr="портрет в анфас без макияжа"
              ></base-image-input>
            </validation-provider>
            <validation-provider
              slim
              vid="fullheight1"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.fullHeight1"
                :error="errors.length > 0"
                deskr="портрет в полный рост в раздельном купальнике"
              ></base-image-input>
            </validation-provider>
            <validation-provider
              slim
              vid="fullheight2"
              rules="required|image|size:5120"
              v-slot="{ errors }"
            >
              <base-image-input
                v-model="request.images.fullHeight2"
                :error="errors.length > 0"
                deskr="портрет в полный рост в раздельном купальнике"
              ></base-image-input>
            </validation-provider>
          </div>
        </div>
        <p class="application-form__recaptcha">This site is protected by reCAPTCHA and the Google 
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and 
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
        <base-button
          :isError="isError"
          :isSuccess="isSuccess"
          class="application-form__button"
          id="re-btn"
          type="submit"
        >
          {{ buttonText }}
        </base-button>
      </form>
    </validation-observer>
  </main>
</template>

<script>
import BaseInput from '../components/BaseInput'
import BaseButton from '../components/BaseButton'
import BaseImageInput from '../components/BaseImageInput'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, alpha_spaces, image, size, regex, numeric } from 'vee-validate/dist/rules'

import { apiUploadRequest } from '../utils/api'

extend('required', required)
extend('alpha_spaces', alpha_spaces)
extend('image', image)
extend('size', size)
extend('regex', regex)
extend('numeric', numeric)

export default {
  name: 'BecomeModel',
  components: {
    BaseInput,
    BaseButton,
    BaseImageInput,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      isUploading: false,
      isError: false,
      isSuccess: false,
      request: {
        name: '',
        location: '',
        phone: '',
        email: '',
        link: '',
        age: '',
        height: '',
        images: {
          nomakeup1: '',
          nomakeup2: '',
          nomakeup3: '',
          portrait: '',
          fullHeight1: '',
          fullHeight2: '',
        }
      }
    }
  },
  computed: {
    buttonText() {
      if (this.isUploading) {
        return 'отправление...'
      } else if (this.isError) {
        return 'ошибка'
      } else if (this.isSuccess) {
        return 'отправлено'
      } else {
        return 'отправить'
      }
    }
  },
  methods: {
    async submitForm() {
      if (this.isUploading) {
        return
      }
      this.isUploading = true
      let success = await this.$refs.form.validate()
      if (!success) {
        this.isUploading = false
        this.isError = true
        setTimeout(() => this.isError = false, 2000)
        return
      }

      // execute recaptcha
      let token = ''
      try {
        await this.$recaptchaLoaded()
        token = await this.$recaptcha('submit')
      } catch(e) {
        console.error(`Error with recaptcha: ${e}`)
      }
      const formData = new FormData()
      formData.append('token', token)
      formData.append('name', this.request.name)
      formData.append('location', this.request.location)
      formData.append('phone', this.request.phone)
      formData.append('email', this.request.email)
      formData.append('link', this.request.link)
      formData.append('age', this.request.age)
      formData.append('height', this.request.height)
      for (let key in this.request.images) {
        formData.append(key, this.request.images[key])
      }

      try {
        const result = await apiUploadRequest(formData)
        if (result) {
          this.isUploading = false
          this.isSuccess = true
          setTimeout(() => this.isSuccess = false, 2000)
          return
        }
      } catch(e) {
        console.error(e.message)
        this.isUploading = false
        this.isError = true
        setTimeout(() => this.isError = false, 2000)
        return
      }
      this.isUploading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/colors";

.become-model {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 80px 100px 0;
}

.application-form {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  grid-template-rows: auto auto;
  column-gap: 50px;
  row-gap: 25px;
  width: 100%;
  max-width: 950px;
  &__info {
    font-size: 10px;
    line-height: 14px;
    margin-bottom: 22px;
    &_mobile {
      display: none;
    }
  }
  &__recaptcha {
    grid-column: 1 / 2;
    color: colors.$gray8b;
    font-size: 10px;
    & > a {
      text-decoration: none;
      color: colors.$blue03;
    }
  }
  &__input:not(:first-of-type) {
    margin-top: 10px;
  }
  &__button {
    grid-column: 1 / 2;
    justify-self: start;
  }
  &__photos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 10px;
    row-gap: 10px;
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .become-model {
    padding: 40px 100px 55px;
  }
  .application-form {
    grid-template-columns: 1fr;
    row-gap: 25px;
    &__recaptcha {
      grid-column: 1 / 2;
    }
  }
}
@media screen and (max-width: 767px) {
  .become-model {
    padding: 15px 12px 55px;
  }
  .application-form {
    &__photos {
      grid-template-columns: 1fr 1fr;
    }
    &__info {
      &_desktop {
        display: none;
      }
      &_mobile {
        display: block;
      }
    }
  }
}
</style>